module.exports = __webpack_public_path__ + "static/media/boredape_earn.bcae054f.png";